import React, { PropsWithChildren } from 'react'

const style = {}

export const Content: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="flex m-0 bg-contentareabackgroundalt flex-grow" style={style}>
    {children}
  </div>
)
